import { WidgetCard } from '@/components/common/WidgetCard';
import { StatTile } from '@/components/common/StatTile';
import { useUsersStats } from '@/features/dashboard/hooks/useDashboard';
import { formatCount } from '@/lib/format';
import { UserCircleIcon } from '@/icons';

/** Users KPI — members of the active organization (organization service). */
export function UsersWidget() {
  const { data, isLoading, isError, refetch } = useUsersStats();
  return (
    <WidgetCard title="Users" icon={UserCircleIcon} isLoading={isLoading} isError={isError} onRetry={refetch}>
      {data && (
        <StatTile
          label="Organization members"
          value={formatCount(data.total)}
          accent="brand"
          sublabel={`${formatCount(data.active)} active`}
        />
      )}
    </WidgetCard>
  );
}
